
import { Component, Vue, Watch } from "vue-property-decorator";
import { Notify } from "quasar";
import Buscador from "@/components/Common/Web/Buscador.vue";
import FirstToolbarComponent from "../Toolbars/FirstToolbarComponent.vue";
import SecondToolbarComponent from "../Toolbars/SecondToolbarComponent.vue";
@Component({
  components: {
    Buscador,
    FirstToolbarComponent,
    SecondToolbarComponent
  }
})
export default class HeaderComponent extends Vue {}
